import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, TabContent, TabPane, NavLink } from "reactstrap";
import classNames from "classnames";

import { generalConfigStore, setActiveTabIndex } from "@store";

import { General } from "./General";

import "@components/Common/Design/index.css";
import "@pages/GeneralConfig/Design/index.css";
import { useSnapshot } from "valtio";

export function Design(): JSX.Element {
    const { t } = useTranslation();
    const { activeAdvertisingScreenTab } = useSnapshot(generalConfigStore);
    const tabs: TabsType[] = [
        {
            title: t("General"),
            content: <General />,
            customClassName: "cgt_txt_general",
        },
    ];

    const [activeTab, setActiveTab] = React.useState<number>(
        activeAdvertisingScreenTab
    );

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
            setActiveTabIndex(tab);
        }
    }

    return (
        <div
            className="design-container-items__clz"
            style={{ height: "591px" }}
        >
            <div
                style={{
                    backgroundColor: "#EDEDED",
                }}
                className="m-2 border-0 rounded"
            >
                <div className="p-2 mt-1 text-center font-weight-bold cursor__clz">
                    {t("Setup options")}
                </div>
                <Nav tabs className="mt-2">
                    {tabs.map((element, index) => {
                        return (
                            <NavItem key={index} style={{ width: "100%" }}>
                                <NavLink
                                    className={classNames(
                                        "nav-link__clz",
                                        {
                                            "active design-tab-nav-tabs-active-link__clz":
                                                activeTab === index,
                                        },
                                        element.customClassName
                                    )}
                                    onClick={() => {
                                        toggleNav(index);
                                    }}
                                >
                                    <span className="mx-2">
                                        {element.title}
                                    </span>
                                </NavLink>
                            </NavItem>
                        );
                    })}
                </Nav>
            </div>
            <TabContent activeTab={activeTab} className="m-2">
                {tabs.map((element, index) => {
                    return (
                        <TabPane tabId={index} key={index} className="h-100">
                            {element.content}
                        </TabPane>
                    );
                })}
            </TabContent>
        </div>
    );
}
